import { render } from "./LeftMenu.vue?vue&type=template&id=cd87e578&scoped=true&ts=true"
import script from "./LeftMenu.vue?vue&type=script&lang=ts"
export * from "./LeftMenu.vue?vue&type=script&lang=ts"

import "./LeftMenu.vue?vue&type=style&index=0&id=cd87e578&lang=scss&scoped=true"

import exportComponent from "/home/build/jenkins/workdir/workspace/fast-build/fast-build/67161/vshow-main/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd87e578"]])

export default __exports__